import * as React from 'react';

import {ButtonCard} from '../card/button-card';

import {MappingCardStatus} from './mapping-card-status';
import {RecentSubmissions} from './recent-submissions';

import styles from './field-mapping-card.module.css';

type Props = {
    icon: React.ReactElement<any>;
    exampleValues: string;
    title: string | null | undefined;
    subtitle?: string | null | undefined;
    needsMapping: boolean;
    onMapField: () => void;
};

export function FieldMappingCard(props: Props) {
    const handleClick = () => props.onMapField();

    return (
        <ButtonCard onClick={handleClick} isFullWidth={true} needsAttention={props.needsMapping}>
            <div className={styles.container}>
                <MappingCardStatus
                    icon={props.icon}
                    title={props.title}
                    subtitle={props.subtitle}
                    actionItem={
                        // This is styled to look like a button but isn't really one
                        // since having a button inside a button card throws an error
                        <div
                            className={
                                props.needsMapping
                                    ? styles['text-primary']
                                    : styles['text-secondary']
                            }
                        >
                            {props.needsMapping ? 'Connect' : 'Edit'}
                        </div>
                    }
                />
                {props.needsMapping ? (
                    <div className={styles.submissions}>
                        <RecentSubmissions exampleValues={props.exampleValues} />
                    </div>
                ) : undefined}
            </div>
        </ButtonCard>
    );
}
